import { IPermissionsContext } from "../../ipermissions-context/ipermissions-context.interface";
import { IPermissions } from "../../ipermissions/ipermissions.interface";
import {
  isPageTypeCampaignBrief,
  isPageTypeExecutionBrief,
  isPageTypeWorkOrder,
  isUserAlsoMerchOwner,
} from "../../ipermissions-context/ipermissions-context.functions";
import { setPermissions } from "../../ipermissions/ipermissions.functions";
import { IPermissionPolicyEvaluator } from "../../ipermissions/ipermission-policy.type";

export const merchOwnerPolicy = (next?: IPermissionPolicyEvaluator) => (
  context: IPermissionsContext,
  permissions: IPermissions
) => {
  // console.log("checkMerchOwnerPolicy -->");
  if (isUserAlsoMerchOwner(context)) {
    // console.log("checkMerchOwnerPolicy --> TRUE");
    setPermissions(
      permissions,
      isPageTypeCampaignBrief(context) || isPageTypeWorkOrder(context),
      "manageProducts"
    );
    setPermissions(permissions, isPageTypeExecutionBrief(context), "canEdit");
  }

  if (next) {
    return next(context, permissions);
  }
};
